import { ScorecardTypes } from "../Component/Model/Enum/BEE123Enums";
import { getDateWithoutTime } from "./DateFormatter";

export function getAllScorecardTypesExceptEE(): number[] {
    const allTypeNumbers = Object.values(ScorecardTypes)
    .filter(value => typeof value === "number" && value !== ScorecardTypes.Employment_Equity) as number[];
  return allTypeNumbers.map(num => num);
  }

export function isExpired(expiryDate: Date): boolean {
    const today = getDateWithoutTime(new Date());
    const expiry = getDateWithoutTime(new Date(expiryDate));
    
    return today > expiry;
}